import _ from "lodash";
import { Box, Divider, Typography, InputLabel, Tooltip ,CircularProgress} from "@mui/material";
import useFetch from "../../../utils/useFetch";
import FormControl from "../../FormControl";
import FormControlWithSubFields from "../../FormControlWithSubFields";
import { useState, useEffect } from "react";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import BaseURL from "../../../utils/base-uri.json";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./ChecklistQuestionnaireContext.css";
import Delayed from "../../../utils/Delayed";
import axios from "../../../utils/fvAxios";
import FormControlLinked from "../../FormControlLinked";
import InfoIcon from "@mui/icons-material/Info";
import sampleData from "./Sample.json";
import { styled } from "@mui/material";


function getInputType(type) {
  switch (type) {
    case "CtrlRadio":
      return "radio";
    case "CtrlCheckBox":
      return "checkbox";
    case "CtrlSelect":
    case "CtrlSelectMultiple":
      return "select";
    case "CtrlTextArea":
      return "textarea";
    case "CtrlTextNumber":
      return "text"; //TODO: Need to changes this from text to number and need to fix the binding issue.
    case "CtrlTextEmail":
      return "email";
    case "CtrlTextMobile":
      return "tel";
    case "CtrlTextPassword":
      return "password";
    case "CtrlTextDate":
      return "date";
    case "CtrlLabel":
      return "label";
    case "CtrlText":
      return "text";
    case "CtrlButton":
      return "button";
    default:
      return "none";
  }
}

function getFieldOptions(str = "") {
  if (str) {
    return str
      .split("|")
      .filter((i) => i.trim())
      .map((i) => ({ id: i, text: i }));
  }
}

function getDefaultUserResponse(field) {
  if (field.type == "CtrlLabel") {
    return field.options;
  }
  return ["CtrlSelectMultiple", "CtrlCheckBox"].includes(field.type)
    ? field.answer?.split("|")
    : field.answer;
}

function getFiledPositioning(alignment) {
  return `${alignment}` === "0" ? "horizontal" : "vertical";
}

function fieldsAdaptor({
  subSection,
  checklistQuestions = [],
  childChecklistSubSections = [],
}) {
  const userResponse = {};
  const userCommentResponse = {};
  const userResponseDependencies = {};

  // const flattenedData = childChecklistSubSections?.flatMap((subSection) =>
  //   subSection.checklistQuestions?.flatMap((q) =>q));
  checklistQuestions = checklistQuestions.map((field) => {
    const newField = {
      id: `${field.checklistQuestionId}`,
      text: field.checklistQuestionText,
      required: field.isMandatory,
      isLinked: field.isLinked,
      heighlight: field.hasHighlights + "",
      inputType: getInputType(field.type),
      expectedValue: field.expectedValue,
      commentPlaceholder: field.commentPlaceholder,
      qFormula: field.qFormula,
      isBold: field.isBold,
    };
    const subFields = field.checklistQuestionColumnDetails || [];

    if (subFields.length === 1) {
      const sf = subFields[0];

      Object.assign(newField, {
        name: `${sf.checklistQuestionColumnDetailsId}`,
        inputType: getInputType(sf.type),
        multiple: sf.type === "CtrlSelectMultiple",
        options: getFieldOptions(sf.options),
        isLinked: sf.isLinked,
        userResponse: getDefaultUserResponse(sf),
        fieldPositioning: getFiledPositioning(sf.alignment),
        Reference: sf.tableReference,
        TableRefFieldValueDisplay:
          sf.tableReference?.qcTableRefFieldValueDisplay,
        TableReference: sf.tableReference?.qcTableReference,
        TableReferenceField: sf.tableReference?.qcTableReferenceField,
        ButtonTypeReferenceValue: sf.buttonTypeReferenceValue,
        questionPlaceholder: sf.questionPlaceholder,
        userCommentResponse: sf.linkToComment,
        questionColor: sf.questionColor,
        questionColorAnswer: sf.questionColorAnswer,
        qFormula: sf.qFormula,
      });

      if (field.dependOn && field.dependOn.length > 0) {
        var parent = field.dependOn[0];
        Object.assign(newField, {
          dependentOn: parent.checklistQuestionId,
          dependentValue: parent.questionValue,
          enableIfParentValue: parent.enableIfParentValue || true,
        });
      }
    } else if (subFields.length > 1) {
      newField.subFields = subFields.map((sf) => {
        return {
          id: sf?.checklistQuestionColumnDetailsId,
          name: sf?.checklistQuestionColumnDetailsId,
          questionId: field.checklistQuestionId,
          inputType: getInputType(sf?.type),
          isLinked: sf?.isLinked,
          multiple: sf?.type === "CtrlSelectMultiple",
          options: getFieldOptions(sf?.options),
          userResponse: getDefaultUserResponse(sf),
          questionPlaceholder: sf.questionPlaceholder,
          userCommentResponse: sf.linkToComment,
          Reference: sf.tableReference,
          TableRefFieldValueDisplay:
            sf.tableReference?.qcTableRefFieldValueDisplay,
          TableReference: sf.tableReference?.qcTableReference,
          TableReferenceField: sf.tableReference?.qcTableReferenceField,
          ButtonTypeReferenceValue: sf.buttonTypeReferenceValue,
          questionColor: sf.questionColor,
          questionColorAnswer: sf.questionColorAnswer,
          qFormula: sf.qFormula,
        };
      });

      newField.fieldPositioning = getFiledPositioning(subFields[0].alignment);
    }

    return newField;
  });

  checklistQuestions.forEach((field, idx, fields) => {
    if (field.subFields) {
      field.subFields.forEach((sf) => {
        _.set(userResponse, [field.id, sf.id], sf.userResponse || "");
        _.set(
          userCommentResponse,
          [field.id, sf.id],
          sf.userCommentResponse || ""
        );
      });
    } else {
      _.set(userResponse, [field.id], field.userResponse || "");
      _.set(userCommentResponse, [field.id], field.userCommentResponse || "");
    }
    if (field.dependentOn) {
      const parent = fields.find((f) => f.id === field.dependentOn);

      if (parent) {
        field.hidden = parent.userResponse !== field.dependentValue;
        _.set(userResponseDependencies, [field.id], {
          parent: parent.id,
          enableIfParentValue: field.enableIfParentValue,
        });
      }
    }
  });
  return {
    checklistQuestions,
    userResponse,
    userResponseDependencies,
    userCommentResponse,
  };
}

function formDataAdaptor(oldData, userResponse, sectionId, subSectionId) {
  const sectionIndex = oldData.findIndex(
    (item) => item.checklistSectionId === sectionId
  );
  if (sectionIndex === -1) return oldData; // Section not found

  const section = _.cloneDeep(oldData[sectionIndex]);
  const subSectionIndex = section.checklistSubSections.findIndex(
    (subSection) => subSection.checklistSubSectionId === subSectionId
  );
  if (subSectionIndex === -1) return oldData; // Subsection not found

  const subSection = section.checklistSubSections[subSectionIndex];

  for (let idx = 0; idx < userResponse.length; idx++) {
    Object.keys(userResponse[idx]).forEach((fieldId) => {
      const newFieldData = userResponse[idx][fieldId];

      if (newFieldData === undefined) return;
      const oldFieldData = subSection.checklistQuestions.find(
        (f) => `${f.checklistQuestionId}` === `${fieldId}`
      );

      if (!oldFieldData) return;

      const oldSubFields = oldFieldData.checklistQuestionColumnDetails || [];

      if (oldSubFields.length === 1) {
        oldSubFields[0]["OldUserInput"] = oldSubFields[0].answer;
        oldSubFields[0].answer = _.isArray(newFieldData)
          ? newFieldData.join("|")
          : newFieldData;
      } else if (oldSubFields.length > 1) {
        oldSubFields.forEach((sf) => {
          if (sf.checklistQuestionColumnDetailsId in newFieldData) {
            sf["OldUserInput"] = sf.answer;
            sf.answer = newFieldData[sf.checklistQuestionColumnDetailsId];
          }
        });
      }
    });
  }
  section.checklistSubSections[subSectionIndex] = subSection;
  oldData[sectionIndex] = section;
  return oldData;
}

export default function ChecklistQuestionnaireContext({
  dataUrl,
  setShowFormButtons,
  setModifiedData,
  reset,
  resetButtons,
  Secid,
  SubId,
  SectionType,
  SubSectionTypeCondition,
  hasUnsavedChanges,
  IsSubSectionCompleted,
  Validate,
  Required,
  SubSectionName,
  Triger,
  VIEWMODE,
  RESETQUESTIONS,
  pqId,
  onGetChecklist,
  disableAll,
  refresh,
  validateAllSubSectionQuestions,
  h1
}) {
  const [resp, setResp] = useState(null);
  const [loading, setLoading] = useState(true);
  // const getChecklist = async () => {
  //   setLoading(true);
  //   const res = await axios.get(
  //     BaseURL.widget.GetCheckList + `?prequalificationId=${pqId}`
  //   );
  //   setResp(res?.data);
  //   setLoading(false);
  // };
  // useEffect(() => {
  //   getChecklist();
  // }, [refresh]);





  useEffect(() => {
    axios.get(BaseURL.widget.GetCheckList + `?prequalificationId=${pqId}`)
      .then((res) => {
        if (res?.data?.responseCode === 100) {
          //setResp(res?.data);
          // setLoading(false);
  
          const checklistData = res?.data?.data;
          if (checklistData && checklistData.checklist) {
            let subSectionIds = [];
            checklistData.checklist.forEach(section => {
              section.checklistSubSections.forEach(subSection => {
                subSectionIds.push(subSection.checklistSubSectionId);
                if (subSection.childChecklistSubSections) {
                  subSection.childChecklistSubSections.forEach(childSubSection => {
                    subSectionIds.push(childSubSection.checklistSubSectionId);
                  });
                }
              });
            });
  
            const uniqueSubSectionIds = new Set(subSectionIds);
            const subSectionIdsString = [...uniqueSubSectionIds].join(',');

           
            
            axios.get("CheckList/GetChklistQuestions?subSectionIds=" + subSectionIdsString + "&prequalificationId=" + pqId)
              .then((resp) => {
                if (resp?.data?.responseCode === 100) {
                  const combinedChecklistData = checklistData.checklist.map(section => {
                    
                    const updatedSubSections = section.checklistSubSections.map(subSection => {

                      const mainQuestions = resp.data.data.filter(question => question.checklistSubSectionId === subSection.checklistSubSectionId);
                      let updatedChildSubSections = subSection.childChecklistSubSections;

                      if (subSection.childChecklistSubSections) {
                        updatedChildSubSections = subSection.childChecklistSubSections.map(childSubSection => {
                          const childQuestions = resp.data.data.filter(question => question.checklistSubSectionId === childSubSection.checklistSubSectionId);
                          return {
                            ...childSubSection,
                            checklistQuestions: childQuestions
                          };
                        });
                      }
                      
                      return {
                        ...subSection,
                        checklistQuestions: mainQuestions, 
                        childChecklistSubSections: updatedChildSubSections 
                      };
                    });
                    return {
                      ...section,
                      checklistSubSections: updatedSubSections
                    };
                  });
                  

                  const newData = { ...res.data };
                  newData.data.checklist = combinedChecklistData; 
                  
                  setResp(newData);

                } else {
                  console.log("Failed to fetch checklist questions");
                }
              })
              .catch(err => {
                console.log(err);
              }).finally(()=>{
                setLoading(false);
              })
          } else {
            console.log("Checklist data or sections are empty");
          }
        } else {
        }
      })
      .catch(err => {
        console.log(err);
      })
      // .finally(() => {
      //   setLoading(false);
      // });
    
  }, [refresh]);


  const [userResponse, setUserResponse] = useState([]);
  const [userCommentResponse, setUserCommentResponse] = useState([]);
  const [userResponseDependencies, setUserResponseDependencies] = useState([]);
  const [checklistQuestions, setChecklistQuestions] = useState([]);
  // const [unhiddenFields, setUnhiddenFields] = useState([]);
  const [sections, setSections] = useState([]);
  const [subSectionArr, setSubSectionArr] = useState([]);

  const [accordiansExpanded, setAccordionsExpanded] = useState([0]);
  const [subAccordiansExpanded, setSubAccordionsExpanded] = useState([]);
  const handleAccordion = (panel) => (event, isExpanded) => {
    if (accordiansExpanded.includes(panel)) {
      const arr = accordiansExpanded.filter((idx) => idx !== panel);
      setAccordionsExpanded(arr);
    } else setAccordionsExpanded((prev) => prev.concat(panel));
  };
  const handleSubAccordion = (panel) => (event, isExpanded) => {
    if (subAccordiansExpanded.includes(panel)) {
      const arr = subAccordiansExpanded.filter((idx) => idx !== panel);
      setSubAccordionsExpanded(arr);
    } else setSubAccordionsExpanded((prev) => prev.concat(panel));
  };

  useEffect(() => {
    if (resp?.data?.checklist?.length > 0) {
      const userResponseList = [];
      const userCommentResponseList = [];
      const userResponseDependenciesList = [];
      const subSectionQuestionsList = [];

      setSections(resp.data.checklist);

      let indexCounter = 0;
      var sample=sampleData;

      const flattenedData = resp.data.checklist?.flatMap((section) =>
      
        section.checklistSubSections?.flatMap((subSection) => ({
        
          subSectionId: subSection.checklistSubSectionId,
          subSectionName: subSection.subSectionName,
          index: indexCounter++,
        }))
      );

    //   const flattenedData = resp.data.checklist?.flatMap((section) =>
    //   section.checklistSubSections?.flatMap((subSection) => {
    //     let subSectionData = [{
    //       subSectionId: subSection.checklistSubSectionId,
    //       subSectionName: subSection.subSectionName,
    //       index: indexCounter++,
    //     }];
    //     if (subSection.childChecklistSubSections) {
    //       subSectionData = subSectionData.concat(
    //         subSection.childChecklistSubSections.map((childSubSection) => ({
    //           subSectionId: childSubSection.checklistSubSectionId,
    //           subSectionName: childSubSection.subSectionName,
    //           index: indexCounter++,
    //         }))
    //       );
    //     }
    //     return subSectionData;
    //   })
    // );
    

      setSubSectionArr(flattenedData);
      
      debugger;
      
      resp.data.checklist.forEach((checklistSection) => {
        if (checklistSection.checklistSubSections) {
          checklistSection.checklistSubSections.forEach((subSection) => {
            const {
              checklistQuestions,
              userResponse,
              userResponseDependencies,
              userCommentResponse,
            } = fieldsAdaptor(subSection);
            userResponseList.push(userResponse);
            userCommentResponseList.push(userCommentResponse);
            subSectionQuestionsList.push(checklistQuestions);
            userResponseDependenciesList.push(userResponseDependencies);
          });
        }
      });
      // setUnhiddenFields([]);
      setUserResponse(userResponseList);
      setUserCommentResponse(userCommentResponseList);
      setUserResponseDependencies(userResponseDependenciesList);

      setChecklistQuestions(subSectionQuestionsList);
      const linkedQuestions = subSectionQuestionsList.map((questionArray) =>
        questionArray.filter((question) => question.isLinked)
      );

      validateAllSubSectionQuestions(subSectionQuestionsList, linkedQuestions);
      onGetChecklist(
        resp.data.checklist.length > 0,
        resp.data.checklistActivity
      );
      subAccordiansExpanded.length === 0 &&
        setSubAccordionsExpanded([
          resp?.data?.checklist[0]?.checklistSubSections[0]
            ?.checklistSubSectionId,
        ]);
    }
  }, [resp]);

  // useEffect(() => {
  //   if (checklistQuestions) {
  //     var unhiddenFieldsList = [];

  //     for (let i = 0; i < checklistQuestions.length; i++) {
  //       unhiddenFieldsList.push(checklistQuestions[i].filter((f) => !f.hidden));
  //       setShowFormButtons(
  //         !!checklistQuestions[i].filter((f) => f.inputType !== "label").length
  //       );
  //     }
  //     setUnhiddenFields(unhiddenFieldsList);
  //   }
  // }, [checklistQuestions]);

  // useEffect(() => {
  //   if (checklistQuestions) {
  //     const unhiddenFieldsList = checklistQuestions.map((questionGroup) =>
  //       questionGroup.filter((f) => !f.hidden)
  //     );
  //     const hasFormButtons = checklistQuestions.some((questionGroup) =>
  //       questionGroup.some((f) => f.inputType !== "label")
  //     );

  //     //setUnhiddenFields(unhiddenFieldsList);
  //     setShowFormButtons(hasFormButtons);
  //   }
  // }, [checklistQuestions]);

  useEffect(() => {
    if (reset) {
      var userResponseList = [];
      var subSectionQuestionsList = [];
      var userResponseDependenciesList = [];

      resp?.data.checklist?.forEach((item) => {
        if (item.checklistQuestions) {
          const { checklistQuestions, userResponse, userResponseDependencies } =
            fieldsAdaptor(item);
          userResponseList.push(userResponse);
          subSectionQuestionsList.push(checklistQuestions);
          userResponseDependenciesList.push(userResponseDependencies);
        }
      });
      setUserResponse(userResponseList);
      setUserResponseDependencies(userResponseDependenciesList);
      setChecklistQuestions(subSectionQuestionsList);
      setModifiedData({});
    }
  }, [reset]);

  useEffect(() => {
    setModifiedData({});
  }, [resetButtons]);

  function onResponseChange(
    fieldId,
    value,
    qColumnId,
    sectionId,
    subSectionId,
    isRequired
  ) {
    const data = _.cloneDeep(userResponse);
    for (let idx = 0; idx < checklistQuestions.length; idx++) {
      const question = checklistQuestions[idx].find((f) => f.id == fieldId);
      if (question && question.id == fieldId) {
        // if (checklistQuestions[idx].some((f) => f.id == fieldId)) {
        // if(checklistQuestions[idx].find((f) => f.id == fieldId))
        //Dependency Questions handling
        for (const [key, value1] of Object.entries(
          userResponseDependencies[0]
        )) {
          if (value1.parent !== fieldId)
            //If the question is not dependent on any question
            continue;

          const dependentField = checklistQuestions[idx].find(
            (f) => f.id === key
          ); //get questions info based on key
          if (dependentField) {
            dependentField.hidden = value !== dependentField?.dependentValue;
            setChecklistQuestions([...checklistQuestions]);
          }
        }

        if (question.subFields) {
          data[idx][fieldId][qColumnId] = value[qColumnId];

          setValidate(
            fieldId,
            data[idx][fieldId][qColumnId],
            isRequired,
            qColumnId
          );
        } else {
          data[idx][fieldId] = value;
          setValidate(fieldId, data[idx][fieldId], isRequired);
        }

        var qFormulaFields = checklistQuestions
          .flat()
          .filter((r) => r.qFormula)
          .map((r) =>
            r.qFormula
              .toString()
              .replace(/\+/g, " ")
              .replace(/-/g, " ")
              .replace(/\*/g, " ")
              .replace(/\//g, " ")
              .replace(/\(/g, " ")
              .replace(/\)/g, " ")
              .split(" ")
          )
          .flat()
          .filter((r) => r && r.startsWith("Q"));

        var QformulaSubFields = checklistQuestions
          .flat()
          .filter((r) => r.subFields)
          .flatMap((r) => r.subFields)
          .filter((r) => r.qFormula)
          .map((r) =>
            r.qFormula
              .toString()
              .replace(/\+/g, " ")
              .replace(/-/g, " ")
              .replace(/\*/g, " ")
              .replace(/\//g, " ")
              .replace(/\(/g, " ")
              .replace(/\)/g, " ")
              .split(" ")
          )
          .flat()
          .filter((r) => r && r.startsWith("Q"));

        if (!qFormulaFields) qFormulaFields = [];
        if (!QformulaSubFields) QformulaSubFields = [];
        //Array.propTypes.push.apply(qFormulaFields,QformulaSubFields);
        Array.prototype.push.apply(qFormulaFields, QformulaSubFields);
        var FormulaDependentQuestions = qFormulaFields.filter(function (
          itm,
          i,
          a
        ) {
          return i == a.indexOf(itm);
        });

        if (FormulaDependentQuestions.includes("Q" + qColumnId)) {
          const questionAndAnsFields = checklistQuestions
            .flat()
            .filter((x) => x.inputType == "text" || x.inputType == "number")
            // .filter((r) => FormulaDependentQuestions.includes("Q" + r.id))
            .map((r1) => ({
              qId: "Q" + r1.name,
              answer: data[idx][r1.id],
              questionId: r1.id,
            }));
          // .map((r1) => ({ qId: "Q" + r1.id, answer: r1.userResponse }));

          const questionAndAnsSubFields = checklistQuestions
            .flat()
            .filter((r) => r.subFields)
            .flatMap((r) => r.subFields)
            .filter((x) => x.inputType == "text" || x.inputType == "number")
            .map((r) => ({
              qId: "Q" + r.id,
              answer: Array.isArray(data[idx][r.questionId])
                ? data[idx][r.questionId][r.id]
                : data[idx][r.questionId],
              questionId: r.questionId,
            }));

          questionAndAnsFields.push(...questionAndAnsSubFields);

          const allFormulaQuestions = checklistQuestions
            .flat()
            .filter((r) => r.qFormula);

          allFormulaQuestions.push(
            ...checklistQuestions
              .flat()
              .filter((r) => r.subFields)
              .flatMap((r) => r.subFields)
              .filter((r) => r.qFormula)
          );

          const _dependedOn = [];
          _dependedOn.push(
            ...getDependentQuestions(
              qColumnId,
              FormulaDependentQuestions,
              allFormulaQuestions
            )
          );

          EvaluateFormulaOfDependent(
            idx,
            _dependedOn,
            data,
            questionAndAnsFields
          );
        }
      }
    }

    setUserResponse(data);
    setModifiedData(formDataAdaptor(sections, data, sectionId, subSectionId));
  }
  function evaluateExpression(expression) {
    const result = eval(expression);
    return !isNaN(result) && isFinite(result) ? result.toString() : "0";
  }
  const EvaluateFormulaOfDependent = (
    idx,
    _dependedOn,
    data,
    questionAndAnsFields
  ) => {
    _dependedOn.forEach((_dependedQuestion) => {
      var currentFormula = _dependedQuestion.qFormula;
      var formulaFields = currentFormula
        .toString()
        .replace(/\+/g, " ")
        .replace(/-/g, " ")
        .replace(/\*/g, " ")
        .replace(/\//g, " ")
        .replace(/\(/g, " ")
        .replace(/\)/g, " ")
        .split(" ")
        .filter((r) => r.startsWith("Q"));

      formulaFields.forEach((formulaField) => {
        var ans = questionAndAnsFields.filter((r) => r.qId == formulaField);
        currentFormula = currentFormula.replace(
          formulaField,
          ans[0].answer.replace(/,/g, "")?.length == 0
            ? "0"
            : ans[0].answer.replace(/,/g, "")
        );
      });

      const answer = evaluateExpression(currentFormula);
      if (
        _.isArray(
          data[idx][_dependedQuestion.questionId ?? _dependedQuestion.id]
        )
      ) {
        // need to check this [_dependedQuestion.questionId ?? _dependedQuestion.id]
        data[idx][_dependedQuestion.questionId][_dependedQuestion.id] = answer;

        const isRequired = checklistQuestions
          .flat()
          .find((r) => r.id == _dependedQuestion?.questionId)?.required;

        if (isRequired)
          setValidate(
            _dependedQuestion.questionId,
            answer,
            isRequired,
            _dependedQuestion.id
          );
        const dependedAnswerField = questionAndAnsFields.find(
          (r) => r.qId === `Q${_dependedQuestion.id}`
        );
        if (dependedAnswerField) {
          dependedAnswerField.answer = answer;
        }
      } else {
        const answer = eval(currentFormula) + "";
        data[idx][_dependedQuestion.id] = answer; // update in response
        if (_dependedQuestion.required)
          setValidate(_dependedQuestion.id, answer, _dependedQuestion.required); // update in Validate object

        const dependedAnswerField = questionAndAnsFields.find(
          (r) => r.qId === `Q${_dependedQuestion.id}`
        );
        if (dependedAnswerField) dependedAnswerField.answer = answer;
      }
      //calculate other questions answer after above calculation
      if (_dependedQuestion.subDependents) {
        EvaluateFormulaOfDependent(
          idx,
          _dependedQuestion.subDependents,
          data,
          questionAndAnsFields
        );
      }
    });
  };
  const getDependentQuestions = (
    qColumnId,
    FormulaDependentQuestions,
    questions
  ) => {
    const _dependedOn = [];
    questions.forEach((question) => {
      if (question.qFormula && question.qFormula.includes(`Q${qColumnId}`)) {
        const matches = question.qFormula.match(/Q(\d+)/);
        if (matches && matches.length > 1) {
          if (FormulaDependentQuestions.includes("Q" + question.id)) {
            _dependedOn.push({
              ...question,
              subDependents: getDependentQuestions(
                question.id,
                FormulaDependentQuestions,
                questions
              ),
            });
          } else _dependedOn.push(question);
          return;
        }
      }
    });
    return _dependedOn;
  };
  const onCommentResponseChange = (
    fieldId,
    value,
    qColumnId,
    sectionId,
    subSectionId,
    isRequired
  ) => {
    const data = _.cloneDeep(userCommentResponse);
    for (let idx = 0; idx < checklistQuestions.length; idx++) {
      const question = checklistQuestions[idx].find((f) => f.id == fieldId);
      if (question && question.id == fieldId) {
        if (question.subFields) {
          data[idx][fieldId][qColumnId] = value[qColumnId];
          setValidate(
            fieldId,
            data[idx][fieldId][qColumnId],
            isRequired,
            qColumnId
          );
        } else {
          data[idx][fieldId] = value;
          setValidate(fieldId, data[idx][fieldId], isRequired);
        }
      }
    }

    setUserCommentResponse(data);
    const updatedOldData = sections.map((section) => {
      if (section.checklistSectionId !== sectionId) {
        return section;
      }

      const updatedSubSections = section.checklistSubSections.map(
        (subSection) => {
          if (subSection.checklistSubSectionId !== subSectionId) {
            return subSection;
          }

          const updatedQuestions = subSection.checklistQuestions.map(
            (question) => {
              if (question.checklistQuestionId != fieldId) {
                return question;
              }
              const updatedColumnDetails =
                question.checklistQuestionColumnDetails.map(
                  (columnDetail, i) => {
                    if (
                      columnDetail.checklistQuestionColumnDetailsId ===
                      qColumnId ||
                      question.checklistQuestionColumnDetails?.length == 1
                    ) {
                      return {
                        ...columnDetail,
                        linkToComment: value,
                      };
                    }
                    return columnDetail;
                  }
                );

              return {
                ...question,
                checklistQuestionColumnDetails: updatedColumnDetails,
              };
            }
          );

          return {
            ...subSection,
            checklistQuestions: updatedQuestions,
          };
        }
      );

      return {
        ...section,
        checklistSubSections: updatedSubSections,
      };
    });

    setModifiedData(updatedOldData);
    setSections(updatedOldData);
  };

  const setValidate = (fieldId, r, isRequired, subSecField = 0) => {
    if (isRequired) {
      Validate(fieldId, r, subSecField);
    }
  };
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))`
    & .MuiTooltip-tooltip {
      background:  rgba(97, 97, 97, 0.92)!important;
      color:#fff !important
    }
       & .MuiTooltip-arrow: {
      color: rgba(97, 97, 97, 0.92)!important;
    }
  `;
  const adjustedHeight = h1 < 150 ? 150 : h1; 
  return (
    <>

      {loading ? (
         <Box className="loading-spinner">
         <Box>
           <CircularProgress />
         </Box>
      
           <Box>
             <Typography variant="subtitle1">loading...</Typography>
           </Box>
     
       </Box>
      ) : sections?.length === 0 ? (
        <Delayed waitBeforeShow={0}>
          <ErrorAlert severity="warning" message={"No results found!"} />
        </Delayed>
      ) : (
        <Box className="p-3 mb-5 checklist-questionnaire" style={{     height: `calc(73vh - ${adjustedHeight}px)`, overflowY: "auto" }}>
          <Accordion className="accordion-root">
            <form>
              {sections?.map((section, sectionIdx) => (
                <div key={sectionIdx}>
                
                  <Accordion
                    className="accordion-root mb-2"
                    expanded={accordiansExpanded.includes(sectionIdx)}
                    onChange={handleAccordion(sectionIdx)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel1a-content-${sectionIdx}`}
                      id={`panel1a-header-${sectionIdx}`}
                    >
                      <Typography variant="subtitle1" component="b" className="font-weight-bold">
                        {section?.sectionName}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails className="p-0 pt-2 ">
                      {section?.checklistSubSections
                        ?.filter((x) => x.parentId == null)
                        .map((subSection, subSectionIdx) => (
                          <div key={subSectionIdx}>
                         
                            <Accordion
                              className="sub-accordion-root mt-1"
                              expanded={subAccordiansExpanded.includes(
                                subSection.checklistSubSectionId
                              )}
                              onChange={handleSubAccordion(
                                subSection.checklistSubSectionId,
                                sectionIdx
                              )}
                            >
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls={`panel2a-content-${subSectionIdx}`}
                                id={`panel2a-header-${subSectionIdx}`}

                              >
                                <Tooltip title={subSection?.subSectionName}>
                                  <Typography variant="subtitle2" component="b" className=" font-weight-bold text-truncate" style={{ maxWidth: "35ch", lineHeight: "1.5" }}>
                                    {subSection?.subSectionName}
                                  </Typography>
                                </Tooltip>
                                {subSection?.sectionNotes &&
                                  <Tooltip title={subSection?.sectionNotes}>
                                    <span>
                                      <InfoIcon className="notes-info ms-auto" />
                                    </span>
                                  </Tooltip>}
                              </AccordionSummary>
                              <AccordionDetails className="px-1">
                                <>
                             
                                  {subSection?.checklistQuestions?.length > 0 &&
                                    checklistQuestions[
                                      subSectionArr.find(
                                        (a) =>
                                          a.subSectionId ==
                                          subSection?.checklistSubSectionId
                                      )?.index
                                    ]?.map((field, fieldIdx) => (
                                      <Box key={fieldIdx}>
                                        {field?.isLinked ? (
                                          <FormControlLinked
                                            questionColor={field?.questionColor}
                                            questionColorAnswer={
                                              field?.questionColorAnswer
                                            }
                                            required={field?.required}
                                            field={field}
                                            fieldId={field?.id}
                                            label={field?.text}
                                            isBold={field.isBold}
                                            linkToData={field}
                                            inputType={field.inputType}
                                            value={
                                              userCommentResponse[
                                              subSectionArr.find(
                                                (a) =>
                                                  a.subSectionId ==
                                                  subSection?.checklistSubSectionId
                                              )?.index
                                              ][field?.id] || ""
                                            }
                                            userResponse={
                                              userResponse[
                                              subSectionArr.find(
                                                (a) =>
                                                  a.subSectionId ==
                                                  subSection?.checklistSubSectionId
                                              )?.index
                                              ][field?.id] || ""
                                            }
                                            disabled={
                                              disableAll || field?.disabled
                                            }
                                            classes=""
                                            placeHolder={
                                              field?.questionPlaceholder ||
                                              "Meet Requirements"
                                            }
                                            handleChange={(value) =>
                                              onCommentResponseChange(
                                                field?.id,
                                                value,
                                                sectionIdx,
                                                section.checklistSectionId,
                                                subSection.checklistSubSectionId,
                                                field?.required
                                              )
                                            }
                                            Reference={field?.Reference}
                                            TableRefFieldValueDisplay={
                                              field?.TableRefFieldValueDisplay
                                            }
                                            TableReference={
                                              field?.TableReference
                                            }
                                            TableReferenceField={
                                              field?.TableReferenceField
                                            }
                                          />
                                        ) : field?.subFields ? (
                                          <FormControlWithSubFields
                                            {...field}
                                            userResponse={userResponse}
                                            onResponseChange={(a, b, c) =>
                                              onResponseChange(
                                                a,
                                                b,
                                                c,
                                                section.checklistSectionId,
                                                subSection.checklistSubSectionId,
                                                field.required
                                              )
                                            }
                                            IDX={
                                              subSectionArr.find(
                                                (a) =>
                                                  a.subSectionId ==
                                                  subSection?.checklistSubSectionId
                                              )?.index
                                            }
                                            VIEWMODE={VIEWMODE}
                                            sectionId={
                                              section.checklistSectionId
                                            }
                                            subSectionId={
                                              subSection.checklistSubSectionId
                                            }
                                            disabledAll={
                                              disableAll || field?.disabled
                                            }
                                            isInsideChecklist={true}
                                            SAVE={() => { }}
                                          />
                                        ) : (
                                          <div className="checklistFormControl">
                                            <FormControl
                                              fieldId={field?.id}
                                              required={field?.required}
                                              label={field?.text}
                                              isBold={field.isBold}
                                              inputType={
                                                subSection?.editAccess ===
                                                  false || VIEWMODE
                                                  ? field?.inputType
                                                  : "label"
                                              }
                                              placeHolder={
                                                field?.questionPlaceholder
                                              }
                                              multiple={field?.multiple}
                                              items={field?.options}
                                              checked={
                                                userResponse[
                                                subSectionArr.find(
                                                  (a) =>
                                                    a.subSectionId ==
                                                    subSection?.checklistSubSectionId
                                                )?.index
                                                ][field?.id] == "true"
                                              }
                                              value={
                                                userResponse[
                                                subSectionArr.find(
                                                  (a) =>
                                                    a.subSectionId ==
                                                    subSection?.checklistSubSectionId
                                                )?.index
                                                ][field?.id] || ""
                                              }
                                              handleChange={(value) =>
                                                onResponseChange(
                                                  field?.id,
                                                  value,
                                                  field?.name,
                                                  section.checklistSectionId,
                                                  subSection.checklistSubSectionId,
                                                  field?.required
                                                )
                                              }
                                              labelPositioning={
                                                field?.labelPositioning ||
                                                "horizontal"
                                              }
                                              fieldPositioning={
                                                field?.fieldPositioning ||
                                                "vertical"
                                              }
                                              width={field?.width}
                                              disabled={
                                                disableAll ||
                                                field?.disabled ||
                                                field?.isLinked ||
                                                field.qFormula
                                              }
                                              color={field?.color}
                                              highlight={field?.highlight}
                                              Reference={field?.Reference}
                                              setValidate={setValidate}
                                              TableRefFieldValueDisplay={
                                                field?.TableRefFieldValueDisplay
                                              }
                                              TableReference={
                                                field?.TableReference
                                              }
                                              TableReferenceField={
                                                field?.TableReferenceField
                                              }
                                              hasUnsavedChanges={
                                                hasUnsavedChanges
                                              }
                                              buttonTypeReferenceValue={
                                                field?.ButtonTypeReferenceValue
                                              }
                                              Pqid={pqId}
                                              Triger={Triger}
                                              reset={reset}
                                              isInsideChecklist={true}
                                              SAVE={() => { }}
                                            />
                                          </div>
                                        )}
                                        {/* {fieldIdx <
                                        subSection.questions.length - 1 && (
                                        <Divider />
                                      )} */}
                                      </Box>
                                    ))}

                                  {subSection?.childChecklistSubSections?.map(
                                    (childSubSection, subSectionIdx) => (
                                      <div
                                        key={subSectionIdx}
                                        className="rounded py-3 my-2 px-3 bg-clr-grey2 border"
                                      >
                                        <Box className="d-flex justify-content-between">
                                          <Typography
                                            className="font-weight-bold mb-1 overflow-hidden text-break"
                                            variant="subtitle1"
                                            component="b"
                                          >
                                            {childSubSection?.subSectionName}
                                          </Typography>
                                          {childSubSection?.sectionNotes && <Tooltip
                                            title={
                                              childSubSection?.sectionNotes
                                            }
                                          >

                                            <span>
                                              <InfoIcon className="notes-info" />
                                            </span>
                                          </Tooltip>}
                                        </Box>
                                        <Divider className="border-secondary my-2" />
                                        {childSubSection?.checklistQuestions
                                          ?.length > 0 &&
                                          checklistQuestions[
                                            subSectionArr.find(
                                              (a) =>
                                                a.subSectionId ==
                                                childSubSection?.checklistSubSectionId
                                            )?.index
                                          ]?.map((field, fieldIdx) => (
                                            <Box key={fieldIdx}>
                                              {field?.isLinked ? (
                                                <FormControlLinked
                                                  fieldId={field?.id}
                                                  label={field?.text}
                                                  isBold={field.isBold}
                                                  questionColorAnswer={
                                                    field?.questionColorAnswer
                                                  }
                                                  questionColor={
                                                    field?.questionColor
                                                  }
                                                  required={field?.required}
                                                  linkToData={field}
                                                  inputType={
                                                    childSubSection?.editAccess ===
                                                      false || VIEWMODE
                                                      ? field?.inputType
                                                      : "label"
                                                  }
                                                  value={
                                                    userCommentResponse[
                                                    subSectionArr.find(
                                                      (a) =>
                                                        a.subSectionId ==
                                                        childSubSection?.checklistSubSectionId
                                                    )?.index
                                                    ][field?.id] || ""
                                                  }
                                                  userResponse={
                                                    userResponse[
                                                    subSectionArr.find(
                                                      (a) =>
                                                        a.subSectionId ==
                                                        childSubSection?.checklistSubSectionId
                                                    )?.index
                                                    ][field?.id] || ""
                                                  }
                                                  disabled={
                                                    disableAll ||
                                                    field?.disabled
                                                  }
                                                  classes="bg-clr-grey2"
                                                  placeHolder={
                                                    field?.questionPlaceholder ||
                                                    "Meet Requirements"
                                                  }
                                                  handleChange={(value) =>
                                                    onCommentResponseChange(
                                                      field?.id,
                                                      value,
                                                      sectionIdx,
                                                      section.checklistSectionId,
                                                      childSubSection.checklistSubSectionId,
                                                      field?.required
                                                    )
                                                  }
                                                  Reference={field?.Reference}
                                                  TableRefFieldValueDisplay={
                                                    field?.TableRefFieldValueDisplay
                                                  }
                                                  TableReference={
                                                    field?.TableReference
                                                  }
                                                  TableReferenceField={
                                                    field?.TableReferenceField
                                                  }
                                                />
                                              ) : field?.subFields ? (
                                                <FormControlWithSubFields
                                                  {...field}
                                                  userResponse={userResponse}
                                                  onResponseChange={(a, b, c) =>
                                                    onResponseChange(
                                                      a,
                                                      b,
                                                      c,
                                                      section.checklistSectionId,
                                                      childSubSection.checklistSubSectionId,
                                                      field.required
                                                    )
                                                  }
                                                  bgClassName="bg-clr-grey2"
                                                  IDX={
                                                    subSectionArr.find(
                                                      (a) =>
                                                        a.subSectionId ==
                                                        childSubSection?.checklistSubSectionId
                                                    )?.index
                                                  }
                                                  VIEWMODE={VIEWMODE}
                                                  sectionId={
                                                    section.checklistSectionId
                                                  }
                                                  subSectionId={
                                                    childSubSection.checklistSubSectionId
                                                  }
                                                  disabledAll={
                                                    disableAll ||
                                                    field?.disabled
                                                  }
                                                  isInsideChecklist={true}
                                                  SAVE={() => { }}
                                                />
                                              ) : (
                                                <div className="checklistFormControl">
                                                  <FormControl
                                                    fieldId={field?.id}
                                                    required={field?.required}
                                                    label={field?.text}
                                                    isBold={field.isBold}
                                                    bgClassName="bg-clr-grey2"
                                                    inputType={
                                                      childSubSection?.editAccess ===
                                                        false || VIEWMODE
                                                        ? field?.inputType
                                                        : "label"
                                                    }
                                                    placeHolder={
                                                      field?.questionPlaceholder
                                                    }
                                                    multiple={field?.multiple}
                                                    items={field?.options}
                                                    checked={
                                                      userResponse[
                                                      subSectionArr.find(
                                                        (a) =>
                                                          a.subSectionId ==
                                                          childSubSection?.checklistSubSectionId
                                                      )?.index
                                                      ][field?.id] == "true"
                                                    }
                                                    value={
                                                      userResponse[
                                                      subSectionArr.find(
                                                        (a) =>
                                                          a.subSectionId ==
                                                          childSubSection?.checklistSubSectionId
                                                      )?.index
                                                      ][field?.id] || ""
                                                    }
                                                    handleChange={(value) =>
                                                      onResponseChange(
                                                        field?.id,
                                                        value,
                                                        field?.name,
                                                        section.checklistSectionId,
                                                        childSubSection.checklistSubSectionId,
                                                        field?.required
                                                      )
                                                    }
                                                    labelPositioning={
                                                      field?.labelPositioning ||
                                                      "horizontal"
                                                    }
                                                    fieldPositioning={
                                                      field?.fieldPositioning ||
                                                      "vertical"
                                                    }
                                                    width={field?.width}
                                                    disabled={
                                                      disableAll ||
                                                      field?.disabled ||
                                                      field?.isLinked ||
                                                      field.qFormula
                                                    }
                                                    color={field?.color}
                                                    highlight={field?.highlight}
                                                    Reference={field?.Reference}
                                                    setValidate={setValidate}
                                                    TableRefFieldValueDisplay={
                                                      field?.TableRefFieldValueDisplay
                                                    }
                                                    TableReference={
                                                      field?.TableReference
                                                    }
                                                    TableReferenceField={
                                                      field?.TableReferenceField
                                                    }
                                                    hasUnsavedChanges={
                                                      hasUnsavedChanges
                                                    }
                                                    buttonTypeReferenceValue={
                                                      field?.ButtonTypeReferenceValue
                                                    }
                                                    Pqid={pqId}
                                                    Triger={Triger}
                                                    reset={reset}
                                                    isInsideChecklist={true}
                                                    SAVE={() => { }}
                                                  />
                                                </div>
                                              )}
                                            </Box>
                                          ))}
                                      </div>
                                    )
                                  )}
                                </>
                              </AccordionDetails>
                            </Accordion>
                          </div>
                        ))}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))}

              {/* {unhiddenFields?.map((fields, idx) => (
                <div key={idx + 100}>
                  <Accordion
                    className="accordion-root mb-2"
                    expanded={accordiansExpanded.includes(idx)}
                    onChange={handleAccordion(idx)}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel1a-content-${idx}`}
                      id={`panel1a-header-${idx}`}
                    ></AccordionSummary>
                    <AccordionDetails>
                      {fields?.map((field, idx1) => (
                        <Box key={field?.id}>
                          {idx < unhiddenFields.length - 1 && <Divider />}
                        </Box>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                </div>
              ))} */}
            </form>
          </Accordion>
        </Box>
      )}
    </>
  );
}

ChecklistQuestionnaireContext.propTypes = {};
ChecklistQuestionnaireContext.defaultProps = {
  onResponseChange: () => { },
};
